import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import Box from "../../widgets/Box/Box";
import Logo from "./Logo";
import ProfileMenu from "./Profile/ProfileMenu";
import ProfileModal from "./Profile/ProfileModal";
import SuccessSnackbar from "../../widgets/Snackbar/SuccessSnackbar";
import routes from "../../constants/routes";

import headerStyles from "./header.module.scss";
import boxStyles from "../../widgets/Box/box.module.scss";

const Header = () => {
  const navigate = useNavigate();

  const [profileOpen, setProfileOpen] = useState(false);
  const [logoutSnackbar, setLogoutSnackbar] = useState({
    open: false,
    message: "",
  });

  const handleLogoutSuccess = () => {
    setLogoutSnackbar({
      open: true,
      message: "You have been logged out successfully.",
    });
  };

  const handleViewProfile = () => {
    setProfileOpen(true);
  };

  const handleCloseProfile = () => {
    setProfileOpen(false);
  };

  return (
    <>
      <AppBar position="static" elevation={0} className={headerStyles.header}>
        <Toolbar className={headerStyles.headerToolbar}>
          <Box
            className={boxStyles.headerLogo}
            onClick={() => navigate(routes.home.root)}
          >
            <Logo />
          </Box>

          <Box className={boxStyles.headerFlexSpacer} />

          <ProfileMenu
            onViewProfile={handleViewProfile}
            onLogoutSuccess={handleLogoutSuccess}
          />
        </Toolbar>
      </AppBar>

      <ProfileModal open={profileOpen} onClose={handleCloseProfile} />

      <SuccessSnackbar
        open={logoutSnackbar.open}
        message={logoutSnackbar.message}
        onClose={() => setLogoutSnackbar({ open: false, message: "" })}
      />
    </>
  );
};

export default Header;
